import { prepareSortedOptions } from '../../prepareOptions';
import {
  AUXILIARY_HEATING,
  AIR_CONDITION,
  AIR_SUSPENSION,
  SPORTS_SUSPENSION,
  HAS_AMBIENT_LIGHTNING,
  HAS_LEATHER_STEERING_WHEEL,
  HAS_SKI_BAG,
  HAS_SMOKERS_PACKAGE,
  HAS_HEATED_STEERING_WHEEL,
  HAS_ELECTRIC_TAIL_GATE,
} from './values';

export default prepareSortedOptions([
  {
    value: AUXILIARY_HEATING,
    label: __('carDetails.equipmentGroups.auxiliaryHeater'),
  },
  {
    value: AIR_CONDITION,
    label: __('carDetails.equipmentGroups.airCondition'),
  },
  {
    value: AIR_SUSPENSION,
    label: __('carDetails.equipmentGroups.airSuspension'),
  },
  {
    value: SPORTS_SUSPENSION,
    label: __('carDetails.equipmentGroups.sportsSuspension'),
  },
  {
    value: HAS_AMBIENT_LIGHTNING,
    label: __('carDetails.features.hasAmbientLighting'),
  },
  {
    value: HAS_LEATHER_STEERING_WHEEL,
    label: __('carDetails.features.hasleatherSteeringWheel'),
  },
  {
    value: HAS_SKI_BAG,
    label: __('carDetails.features.hasSkiBag'),
  },
  {
    value: HAS_SMOKERS_PACKAGE,
    label: __('carDetails.features.hasSmokersPackage'),
  },
  {
    value: HAS_HEATED_STEERING_WHEEL,
    label: __('carDetails.features.hasHeatedSteeringWheel'),
  },
  {
    value: HAS_ELECTRIC_TAIL_GATE,
    label: __('carDetails.features.hasElectricTailGate'),
  },
]);
